import { InviteLink } from '../types/invites';
import { LinkInfo } from '../types/misc';
import httpService from './httpService';

/**
 * Returns the data behind a redirect link including the
 * id of the link itself
 *
 * @param linkId the id of the link to fetch
 * @return `{ ...linkData, linkId }`
 */
export async function getLinkInfo(linkId: string): Promise<LinkInfo & { linkId: string }> {
  const linkData = await httpService.get<LinkInfo>(`/links/${linkId}`).then(({ data }): LinkInfo => data);
  return { ...linkData, linkId };
}

export async function getInviteByFriendlyId(friendlyId: string): Promise<InviteLink> {
  const invite = await httpService
    .get<InviteLink>(`/networks/invite-links/${friendlyId}`)
    .then(({ data }): InviteLink => data);
  return invite;
}
